// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2TinX","colCheckbox":"styles_colCheckbox__u9blt"};